import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 187 210" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20.4 2.7l159.3 90.6c9.2 5.2 9.2 18.5 0 23.7L20.4 207.6C11.3 212.8 0 206.2 0 195.7V14.6C0 4.1 11.3-2.5 20.4 2.7z" /></svg>);